import { PAYMENTS } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import PaymentsPage from "./container/PaymentsPage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.auth],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: PAYMENTS,
    withSidebar: true,
    withAppBar: true,
    component: PaymentsPage,
  };
}
